module.exports = "/packs/media/images/moving-c82b4cfd8c5feab03475786181d464fc.png";